module.exports = __webpack_public_path__ + "static/media/myopic-eye-diagram.713e7fcf.png";